import { useEffect, useState, useCallback } from 'react';

const KEY = 'fymua_wishlist';

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};

export const useWishlist = () => {
  const [slugs, setSlugs] = useState([]);

  useEffect(() => { setSlugs(read()); }, []);

  const toggle = useCallback((slug) => {
    setSlugs(prev => {
      const next = prev.includes(slug) ? prev.filter(s => s !== slug) : [...prev, slug];
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const has = useCallback((slug) => slugs.includes(slug), [slugs]);

  return { slugs, toggle, has };
};
